const styles = () => ({
  dashboardChartLegends: {
    display: 'flex',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/ChartLegendPanel/styles.js